import { Box } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { TextBold } from 'UiKit/typography';

import { useHostAttendanceRecordState } from 'View/host-attendance-record/state';

import styles from './styles.module.css';

const AttendanceBanner = ({ isClockedIn }) => {
  const { t } = useTranslation('host-attendance');
  const { state } = useHostAttendanceRecordState();

  const bannerText = isClockedIn ? t('clock_out') : t('clock_in');

  const bannerHeight = state?.currentStep === 2 ? '50px' : '90px';

  return (
    <Box className={styles['attendance-banner__container']} style={{ height: bannerHeight }}>
      <TextBold fontSize="var(--font-heading7)">{bannerText}</TextBold>
    </Box>
  );
};

export default AttendanceBanner;
